import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {ComponentModule} from 'app/component/component.module';
import {RatioTableComponent} from 'app/tool-layer/tools/ratio-table/ratio-table.component';

@NgModule({
    imports: [CommonModule, ComponentModule],
    declarations: [RatioTableComponent],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(RatioTableComponent),
            multi: true,
        },
    ],
})
export class RatioTableModule {}
